import classNames from 'classnames/bind'

// Components
import Banner from '../../Live/components/Banner'

// Constants
import { MAX_MOBILE_WIDTH } from '@/constants/layout'
import { BANNER_IMAGE_SIZE } from '@/constants/banner'
import { BANNER_LOCATION } from '@/constants/banner'

// Libs
import { useBannerList } from '../../Live/components/Banner/hooks/useBannerList'
import { useWindowWidth } from '@react-hook/window-size'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

const HomeBannerCarousel = () => {
  const viewportWidth = useWindowWidth()
  const { bannerList } = useBannerList({
    location:
      viewportWidth >= MAX_MOBILE_WIDTH ? BANNER_IMAGE_SIZE[`${BANNER_LOCATION.HOME}_DESKTOP`] : BANNER_IMAGE_SIZE[`${BANNER_LOCATION.HOME}_MOBILE`],
    cache: 0,
  })

  if (bannerList?.data?.length < 1) return null

  return <Banner location={BANNER_LOCATION.HOME} className={cx('home-banner-carousel')} />
}

export default HomeBannerCarousel
